// Central contact details for Euro Mobile & Computer
export const contact = {
  phoneDisplay: "01282 761818",
  phoneHref: "tel:+441282761818",
  whatsappHref: "https://wa.me/447869492537",
  whatsappNumber: "447869492537",
  whatsappDisplay: "+44 786 94 92 537",
  email: "info@euromobilecomputer.co.uk",
  addressLine1: "60 Keirby Walk",
  addressLine2: "Burnley, BB11 2DE",
  addressFull: "60 Keirby Walk, Burnley, BB11 2DE, United Kingdom",
  mapQuery: "60+Keirby+Walk,+Burnley,+BB11+2DE",
  directionsHref: "https://www.google.com/maps/dir/?api=1&destination=60+Keirby+Walk,+Burnley,+BB11+2DE",
  hours: "Mon–Sat, 10am–6pm",
};
